import React from "react";
import styles from "./HeroSection.module.css";

const feats = [
    {
        id: 1,
        stats: "10,000+",
        title: "Tasks Completed",
    },
    {
        id: 2,
        stats: "500+",
        title: "Verified Vendors",
    },
     {
        id: 3,
        stats: "12+",
        title: "Cities Served",
    },
     {
        id: 4,
        stats: "98%",
        title: "Client Satisfaction",
    },
]

function Hero() {
    return (
        <section className={styles.HeroContainer}>
            <div className={styles.textContainer}>
                <p className={styles.firstP}>About <span>Oya Concierge</span></p>
                <h1>We make life easier, one task at a time.</h1>
                <p className={styles.secondP}>
                    Oya Concierge is a digital marketplace connecting busy professionals and individuals with trusted concierge service providers — from errands and 
                    travel planning to event coordination and personal shopping.
                </p>
            </div>

            <div className={styles.featContainer}>
                {feats.map((feat, index) =>(
                    <div className={styles.featCard}>
                        <p className={styles.stats}>{feat.stats}</p>
                        <p className={styles.title}>{feat.title}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
export default Hero